
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning/prepare-for-ielts-exam",
      function () {
        return require("private-next-pages/elearning/prepare-for-ielts-exam.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning/prepare-for-ielts-exam"])
      });
    }
  